import React from 'react'
import Layout from '../components/layout'
import { graphql } from "gatsby"
const Datenschutz = (props) => {
    return(
      <Layout title={props.data.site.siteMetadata.title}>
      <h2>Im Moment ist die Seite noch im Aufbau</h2>
      <p>Deshalb sind noch keine Tools implementiert, die Daten von Usern in irgendeiner Form speichern.</p>
      <p>Die folgenden Bestimmungen werden erst gültig, wenn dieser Hinweise gelöscht wurde.</p>
      <h1>Unsere Datenschutzbestimmungen</h1>
                  <p>Wir möchten Dich umfassend über unsere Datenbestimmungen informieren.<br/>Daten sind eine sensible Angelegenheit und es ist sehr wichtig, dass Du         Sie immer infomierst, was mit Deinen Daten passiert.
                Alle Fragen und Auskunftswünsche bitte per Email an den Betreiber und Datenschutzbeauftragten der Webseite.<br/>
                <a href="mailto:wohnen-im-mittelrheintal@gmx.de">Email an Karin Leue</a></p>
            <p>
                Wir nutzen Deine Daten nicht kommerziell. Deshalb speichern wir als Betreiber
                keine Daten von Dir, die wir an Dritte zur Nutzung weiterverkaufen. 
                Das was uns interessiert ist, von welchem Ort in der Welt welche Seiten besucht werden, 
                wie stark das Interesse an bestimmten Seiten ist, welche Seiten nur wenig Interesse erzeugen.
                So können wir die Lernplattform für Sie verbessern.
                Was wir nicht wissen wollen ist, welche konkrete Person welche Daten abruft.
                Wir haben Google Analytics implementiert. Die Daten die Google zur Analyse
                der Webseitenaufrufe bereitstellt, werden anonymisiert, so kann Google die Daten nicht 
                persönlich mit Dir in Verbindung bringen. (Deine IP-Adresse wird gekürzt in der Kommunikation mit
                GoogleServern).
                Die temporär gesetzten Cookies - kleine Textdateien in Deinem Browser - werden von Google gesetzt.
                In Deinem Browser kannst Du das Setzen von Cookies vollständig abstellen.
                Wenn Du magst, kannst Du auch Google Analytics vollständig in Deinem Browser deaktivieren.
                Siehe dazu folgenden Link: <br/>
                    <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noreferrer noopener">Google Analytics deaktivieren</a>
                        <br/>
  
                Natürlich kannst Du auch jederzeit von uns Auskunft verlangen, ob und welche Daten wir von Dir gespeichert haben.
                Sollte das der Fall sein, hast Du jedem Webseitenbetreiber gegenüber das Recht die Löschung dieser Daten
                zu verlangen.
  
                Was wird noch an Daten gespeichert?
                Damit eine Website besucht werden kann, muss Sie von einem Provider im Netz angeboten werden.
                Der Provider darf nur technische Daten für eine kleine Zeitspanne speichern.
                Dazu gehört Deine IP-Adresse, die Login-Daten mit Daten und Dauer des Besuchs,
                Infos über den verwendeten Browser usw.
                <br/>
                Diese vom Provider temporär gespeicherten Daten können bzw. dürfen nicht mit Dir persönlich 
                in Beziehung gebracht werden.<br/>
                Nutzt Du Social Apps wie Facebook oder auch andere Webseiten, informiere Sie,
                welche Daten von Dir übertragen werden. Du hast ein Auskunftsrecht und das Recht auf Löschung aller Daten bei den jeweiligen Betreibern
                von Webseiten und Anbietern von Social Apps.
                Manchmal findest Du auch Links zu Youtube. Youtube sammelt und handelt mit Daten, auch mit Deinen Daten.
                Wenn Du das nicht willst, verzichte auf Klicks zu Youtube!. 
                </p><p>Das gleiche gilt für Google Translate und den hier bereitgestellten Übersetzungsdienst. <br/>
                Wie und was Google an Daten abschöpft in Kombination mit allen anderen Softwarezeugnissen eigener und 
                fremder Kooperationspartner kann schlecht eingeschätzt werden.<br/> Hast Du Bedenken irgendwelcher Art, dann
                empfehlen wir Dir, auch Google Translate nicht zu benutzen.<br/> Es gibt nichts umsonst im Internet.
                Wir bezahlen immer mit den Daten, die wir diesen Unternehmen zur Verfügung stellen durch die Benutzung der vorgelblich
                kostenlosen Softwareprodukte.
                </p>
                <p>Der Webseitenbetreiber dieser Seite ist nicht interessiert an persönlichen Daten. Wir geben auch keine Daten 
                    an Dritte weiter!
                </p>
                
                <p>Im Moment nutzen wir keine Social Apps wie Facebook oder Instagram. Sollten wir uns anders entscheiden,
                    informieren wir Sie auf dieser Webseite.
                </p>
  
                <p>Für Verlinkungen und deren Inhalt auf und über unsere Seite übernehmen wir keine Verantwortung.</p>
                <p>Wenn Du mit unseren Datenschutzbestimmungen nicht einverstanden bist,
                    dann verlasse bitte jetzt unsere Webseite.<br/>
                    Ansonsten klicke auf unten stehenden Button und stimme unseren Datenschutzbestimmungen zu.
                </p>
                
                    <h2>privacy policy</h2>
               <p> We would like to inform you comprehensively about our data regulations. Data is a sensitive matter
  and it is very important that you always know what is happening to your data. Please send all questions and requests for information by email to the operator of the website.
  </p><a href="mailto:wohnen-im-mittelrheintal@gmx.de">Email to Karin Leue</a>  <p>We do not use your data commercially. Therefore we store as operators
  no data from you, which we resell to third parties for use. What interests us is from which place in the world which pages are visited, 
  how strong the interest in certain pages is, which pages generate only little interest. So we can improve the learning platform for you.
  What we do not want to know is which specific person retrieves which data. We have implemented Google Analytics. The data the Google for analysis
  of the website calls are made anonymous, so Google cannot personally connect the data with you. (Your IP address will be shortened in the communication with
  GoogleServers). The temporarily set cookies - small text files in your browser - are set by Google. In your browser you can completely disable the setting of cookies. If you like, you can also deactivate Google Analytics completely in your browser. See the following link: <br/> <a target="_blank" rel="noreferrer noopener" href="https://tools.google.com/dlpage/gaoptout?hl=en">Deactivate Google Analytics</a> <br/>  
  Of course, you can also request information from us at any time as to whether and which data we have stored about you. Should this be the case, you have the right to demand the deletion of this data from any website operator.
  to demand. What other data is stored?
  In order for a website to be visited, it must be offered on the Internet by a provider. The provider may only store technical data for a small period of time.
  This includes your IP address, the login data with data and duration of the visit, information about the browser used, etc. These data temporarily stored by the provider cannot or must not be related to you personally. If you use social apps such as Facebook or other websites, inform yourself,
  which data will be transmitted by you. You have a right to information and the right to deletion of all data with the respective operators.
  of websites and providers of social apps.
  Sometimes you can also find links to Youtube. Youtube collects and trades data, including your data.
  If you don't want this, don't click on Youtube! 
  There is nothing for free on the Internet. We always pay with the data that we make available to these companies by using the free software products.
  At the moment we do not use social apps like Facebook or Instagram. If we decide otherwise, we will inform you on this website.
  We assume no responsibility for links and their content on and via our site.
  If you do not agree with our privacy policy, please leave our website now. Otherwise click on the button below and agree to our privacy policy.
                
                
  <br/>
  Translated with www.DeepL.com/Translator
                </p>
           
         
        </Layout>
         
    )
   
  
  }
  export default Datenschutz
  export const datQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
}`
